module.exports = __webpack_public_path__ + "components/rewards/skiset/static/logo-f5a70bb8e5bc79182b79134243a11202.webp";